export function colorByPerformance(v: number) {
  return v > 0
    ? 'text-green-700 dark:text-green-400'
    : v < 0
      ? 'text-red-700 dark:text-red-400'
      : 'text-gray-800 dark:text-white'
}
